<template>
  <v-card class="mx-8 my-6" :style="cardClass" v-if="details.accessories">
    <data-card
      v-for="(accessory, i) in details.accessories.items"
      :key="i"
      :noMargin="true"
    >
      <div class="font-weight-bold">
        {{ accessory.name }}
      </div>
      <div class="d-flex justify-space-between">
        <div class="d-flex">
          <v-checkbox
            class="ma-0 pa-0"
            value="PRESENT"
            dense
            color="secondary"
            @click="updateSession()"
            v-model="accessory.status"
          ></v-checkbox
          ><span>Present</span>
        </div>
        <div class="d-flex">
          <v-checkbox
            class="ma-0 pa-0"
            value="BROKEN"
            dense
            color="secondary"
            @click="updateSession()"
            v-model="accessory.status"
          ></v-checkbox
          ><span>Broken</span>
        </div>
        <div class="d-flex">
          <v-checkbox
            class="ma-0 pa-0"
            dense
            value="MISSING"
            color="secondary"
            @click="updateSession()"
            v-model="accessory.status"
          ></v-checkbox
          ><span>Missing</span>
        </div>
      </div>
    </data-card>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import DataCard from '@/components/app/DataCard.vue';
import ReconciliationDetailData from '@/mixins/ReconciliationDetailData';
import { MobileView } from '@/mixins';
import card from '@/mixins/card';

export default {
  mixins: [ReconciliationDetailData, MobileView, card],
  components: {
    DataCard,
  },
  data: () => ({
    accessories: [],
  }),
  computed: {
    cardClass() {
      if (this.showMobileView) {
        return 'overflow:hidden; width:100%';
      }
      return 'width:30%; overflow:hidden; height:fit-content;';
    },
  },
  methods: {
    ...mapActions({
      _uploadDetails: 'reconciliationDetails/uploadDetails',
    }),
    updateSession() {
      this._uploadDetails(this.details);
    },
  },
};
</script>

<style></style>
